function upsertMeta(selector, attributes, content) {
  let element = document.head.querySelector(selector);

  if (!element) {
    element = document.createElement('meta');
    Object.entries(attributes).forEach(([key, value]) => element.setAttribute(key, value));
    document.head.appendChild(element);
  }

  element.setAttribute('content', content);
}

function upsertLink(selector, attributes) {
  let element = document.head.querySelector(selector);

  if (!element) {
    element = document.createElement('link');
    document.head.appendChild(element);
  }

  Object.entries(attributes).forEach(([key, value]) => element.setAttribute(key, value));
}

function upsertStructuredData(data) {
  const selector = 'script[data-seo-schema="true"]';
  let element = document.head.querySelector(selector);

  if (!data) {
    if (element) {
      element.remove();
    }
    return;
  }

  if (!element) {
    element = document.createElement('script');
    element.type = 'application/ld+json';
    element.setAttribute('data-seo-schema', 'true');
    document.head.appendChild(element);
  }

  element.textContent = JSON.stringify(data);
}

export function applySeo({
  title,
  description,
  keywords,
  robots = 'index,follow',
  canonical,
  ogTitle,
  ogDescription,
  ogType = 'website',
  ogUrl,
  twitterCard = 'summary_large_image',
  twitterTitle,
  twitterDescription,
  themeColor,
  structuredData = null,
}) {
  if (typeof document === 'undefined') {
    return;
  }

  if (title) {
    document.title = title;
  }

  if (description) {
    upsertMeta('meta[name="description"]', { name: 'description' }, description);
  }

  if (keywords) {
    upsertMeta('meta[name="keywords"]', { name: 'keywords' }, keywords);
  }

  if (robots) {
    upsertMeta('meta[name="robots"]', { name: 'robots' }, robots);
  }

  if (themeColor) {
    upsertMeta('meta[name="theme-color"]', { name: 'theme-color' }, themeColor);
  }

  upsertMeta('meta[property="og:title"]', { property: 'og:title' }, ogTitle || title || 'ClientWay');
  upsertMeta('meta[property="og:description"]', { property: 'og:description' }, ogDescription || description || 'ClientWay');
  upsertMeta('meta[property="og:type"]', { property: 'og:type' }, ogType);

  if (ogUrl || canonical) {
    upsertMeta('meta[property="og:url"]', { property: 'og:url' }, ogUrl || canonical);
  }

  upsertMeta('meta[property="og:site_name"]', { property: 'og:site_name' }, 'ClientWay');
  upsertMeta('meta[property="og:locale"]', { property: 'og:locale' }, 'pl_PL');

  upsertMeta('meta[name="twitter:card"]', { name: 'twitter:card' }, twitterCard);
  upsertMeta('meta[name="twitter:title"]', { name: 'twitter:title' }, twitterTitle || ogTitle || title || 'ClientWay');
  upsertMeta('meta[name="twitter:description"]', { name: 'twitter:description' }, twitterDescription || ogDescription || description || 'ClientWay');

  if (canonical) {
    upsertLink('link[rel="canonical"]', { rel: 'canonical', href: canonical });
  }

  upsertStructuredData(structuredData);
}